<template>
    <v-container>    
        <div class="limiter-content pa-2 pa-lg-0">
            
            <v-row>
                <v-col>
                    <div class="font-weight-bold mt-10 title-page" tabindex="0">Análise de Ofício</div>
                </v-col>
            </v-row>
    
            <br />
            <div v-html="dataset.description" tabindex="0"></div>   
            <v-divider></v-divider>       
            <div class="mt-4" v-if="dataset.loading">
                <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
            </div>
            
            <br />

            <v-container v-if="user">
                <v-row v-if="!dataset.loading && dataset.analysisList.length === 0">
                    <v-col>
                    <v-alert type="info">
                        <span>Nenhuma análise de ofício disponível</span>
                    </v-alert>
                    </v-col>
                </v-row>
                <template v-if="dataset.analysisList.length > 0">
                  <div v-for="(analysis, index) in dataset.analysisList" :key="index">
                        <v-row>
                            <v-col>
                                <Strong>Análise de Ofício #{{ index + 1 }}</Strong>
                                <br />
                                <strong class="mt-2">Nome: </strong>
                                <span> {{ analysis.name}}</span>
                                <br/>
                                <strong class="mt-2">CPF/CNPJ: </strong>
                                <span>{{formatRegistration(analysis.registration)}}</span>
                                <br />
                                <strong class="mt-2">Valor: </strong>
                                <span>{{ analysis.amount | currency }}</span>
                                <br />
                                <strong class="mt-2">Motivo: </strong>
                                <span v-if="truncateReason(analysis.reason).length > 50 && !analysis.showFullReason" v-html="truncateReason(analysis.reason)"></span>
                                <span v-else v-html="analysis.reason"></span>
                                <button v-if="truncateReason(analysis.reason).length > 50 && !analysis.showFullReason" @click="toggleReason(index)" class="ver-mais font-weight-bold">Ver Mais</button>
                                <button v-if="analysis.showFullReason" @click="toggleReason(index)" class="ver-mais font-weight-bold">Ver Menos</button>
                                
                            </v-col>    
                        </v-row> 
                    </div>
                </template>
            </v-container>
            <v-divider></v-divider>

            <div class='mt-10' v-if='!user'>
                <h4>Por favor, realize o seu login para ter acesso à Análise de Ofício.</h4>
            </div>

            
        </div>
    </v-container>
</template>
        
<script>
import 'moment/locale/pt-br';
import axios from 'axios';

import { eventHub } from "@/main";
//import topButton from '@/components/layout/GoToTopButton.vue';
//import whatsButton from '@/components/layout/WhatsAppButton.vue';

export default {
  // components: {
  //     topButton,
  //     whatsButton,
  // },

  data: () => ({
    user: null,
    dialogPopup: false,
    dataset: {
      documents: [],
      description: '',
      loading: false,
      analysisList: [],
    }
  }),

  mounted: function () {
  },

  created() {
    if (this.$root.user) {
      this.user = this.$root.user;
      this.loadAnalysis();
      this.loadText();
    }
  },

  methods: {
    formatCpf(value) {
      if (!value) return '';
      return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
    },

    formatCnpj(value) {
      if (!value) return '';
      return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    },

    formatRegistration(value) {
      if (!value) return '';
      return value.length <= 11 ? this.formatCpf(value) : this.formatCnpj(value);
    },

    openRegister() {
      eventHub.$emit("DIALOG-REGISTER", true)
    },

    async loadText() {
      try {
        const result = await axios.get(`/api/dynamic-infos/keys`, {
          params: { keys: 'official-analysis-description' }
        });

        if (result.data.content && result.data.content.length > 0) {
          this.dataset.description = result.data.content[0].value;
        } else {
          this.dataset.description = '';
        }

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      }
    },

    async loadAnalysis() {
      this.dataset.loading = true;

      try {
        const result = await axios.get('/api/officio-analysis-lawyer');

        if (result.data && result.data.content && Array.isArray(result.data.content.data)) {
          this.dataset.analysisList = result.data.content.data.map(analysis => ({
            ...analysis,
            showFullReason: false 
          }));
        } else {
          this.dataset.analysisList = [];
        }

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 5000
        })
      } finally {
        this.dataset.loading = false;
      }
    },

    truncateReason(reason) {
      if (!reason) return '';
      const textWithoutHtml = reason.replace(/<[^>]*>?/gm, ''); // Remove tags HTML
      return textWithoutHtml.length > 50 ? textWithoutHtml.slice(0, 50) + '...' : textWithoutHtml;
    },

    toggleReason(index) {
      this.dataset.analysisList = this.dataset.analysisList.map((analysis, i) => {
        if (i === index) {
          return { ...analysis, showFullReason: !analysis.showFullReason };
        }
        return analysis;
      });
    }

  }
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: "Raleway";
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}
.ver-mais {
  background: none;
  border: none;
  color: var(--v-primary-base);
  cursor: pointer;
  padding: 0;
  margin-top: 5px;
}

.ver-mais:hover {
  text-decoration: underline;
}
</style>
